import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Topbar from './Topbar';
import { applyThemeClass, readStoredTheme } from '../../utils/theme';

import { syncMomentLocale } from '../../locales';
syncMomentLocale();

function Public() {
    // Public pages (devis, changelog…) must stay light regardless of user/system dark preference.
    useEffect(() => {
        applyThemeClass('light');
        return () => {
            applyThemeClass(readStoredTheme());
        };
    }, []);

    return (
        <div className="Public min-h-screen bg-white text-gray-900">
            <Topbar />
            <div className="flex">
                <div className="w-full">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default Public;
